module.exports = __webpack_public_path__ + "src/app/assets/images/askanews.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/askanews.png
// module id = 633
// module chunks = 0